/* ==========================================================================
   AMALGAM NAV — Horizon theme — G&V March 2026
   ========================================================================== */

(function () {
  'use strict';

  var sidenav  = document.getElementById('mySidenav');
  var closeBtn = document.getElementById('amalgam-sidenav-close');
  var body     = document.body;

  if (!sidenav) return;

  /* Mobile = anything under 1300px */
  var isMobile = window.innerWidth < 1300;
  window.addEventListener('resize', function () { isMobile = window.innerWidth < 1300; });

  function qsa(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function qs(sel, scope)  { return (scope || document).querySelector(sel); }


  /* --------------------------------------------------------------------------
     RESET
     -------------------------------------------------------------------------- */
  function fullReset() {
    qsa('.sidebar-link', sidenav).forEach(function (p) {
      p.classList.remove('sidebar-link-active', 'active-menu');
      p.style.cssText = '';
      var heading = qs('.desktop-title', p);
      if (heading && heading.dataset.originalTitle) {
        heading.textContent = heading.dataset.originalTitle;
      }
    });
    qsa('.sidebar-child-list', sidenav).forEach(function (l) {
      l.classList.remove('active-child-link');
    });
    qsa('.child-link', sidenav).forEach(function (cl) {
      cl.classList.remove('active-grandchild-link');
      cl.style.cssText = '';
      var menuToggle = qs('.menu-toggle', cl);
      if (menuToggle) menuToggle.style.display = '';
    });
    qsa('.sidebar-grandchild-container', sidenav).forEach(function (gc) {
      gc.classList.remove('active-background', 'mobile-active');
      qsa('.sidebar-grandchild-list li', gc).forEach(function (li) {
        li.classList.remove('textAnimation');
      });
    });
    qsa('.backbtn', sidenav).forEach(function (btn) {
      btn.style.display = 'none';
      btn.classList.remove('back-first-level', 'back-second-level');
    });
    qsa('.menu-toggle', sidenav).forEach(function (t) {
      t.classList.remove('menu-load-in');
    });
  }


  /* --------------------------------------------------------------------------
     OPEN / CLOSE
     -------------------------------------------------------------------------- */
  function openOverlay() {
    sidenav.classList.add('sidenav-visible');
    sidenav.setAttribute('aria-hidden', 'false');
    body.classList.add('sidenav-open');
  }

  function closeSidenav() {
    sidenav.classList.remove('sidenav-visible');
    sidenav.setAttribute('aria-hidden', 'true');
    body.classList.remove('sidenav-open');
    fullReset();
    var drawerDetails = document.getElementById('Details-menu-drawer-container');
    if (drawerDetails) drawerDetails.removeAttribute('open');
    var menuDrawer = document.querySelector('menu-drawer');
    if (menuDrawer) menuDrawer.removeAttribute('open');
  }


  /* ==========================================================================
     DESKTOP
     ========================================================================== */

  function showGrandchildren(grandchildId, parentPanel) {
    var newGc = document.getElementById(grandchildId);
    if (!newGc) return;

    var alreadyActive = newGc.classList.contains('active-background');
    newGc.style.removeProperty('opacity');
    newGc.style.removeProperty('box-shadow');

    /* Restore original background if overwritten by a plain link hover */
    if (newGc.dataset.originalBg !== undefined) {
      newGc.style.backgroundImage = newGc.dataset.originalBg || '';
      delete newGc.dataset.originalBg;
    }

    newGc.classList.remove('sidebar-grandchild-container-initial');
    newGc.classList.add('active-background');
    var newInner = qs('.sidebar-grandchild-inner-container', newGc);
    if (newInner) newInner.style.removeProperty('display');

    /* Widen the single frosted-glass element (.sidenav::before) to also cover
       this marque list, so a short list gets a narrow reach and a two-column
       list a wider one. Measure the list's right edge; the frost runs from the
       left edge to there (+ matching breathing room), clamped to the clear
       last third unless the text itself runs past it. One element = no seam. */
    if (!isMobile) {
      var gcList = qs('.sidebar-grandchild-list', newGc) || qs('ul', newInner);
      if (gcList) {
        var vw = window.innerWidth;
        var panelRight = 0.30 * vw;            /* left link panel edge (30%) */
        var maxRight = 0.66 * vw;              /* never past the last-third line */
        /* Measure the actual link extents, not the ul box: the ul is full width
           (definite, for Safari), so its box no longer hugs the text. */
        var links = qsa('a', gcList);
        var textLeft = Infinity, textRight = 0;
        links.forEach(function (a) {
          var r = a.getBoundingClientRect();
          if (r.width) { if (r.left < textLeft) textLeft = r.left; if (r.right > textRight) textRight = r.right; }
        });
        if (!isFinite(textLeft)) { textLeft = gcList.getBoundingClientRect().left; textRight = textLeft; }
        /* Match the right margin to the list's left inset (its inset from 30%),
           so the frost has the same breathing room on both sides of the text. */
        var margin = Math.max(textLeft - panelRight, 0);
        /* The 66% line never cuts text: on narrow (1366px) or short windows the
           columns run past it, so the frost follows the text (24px min room). */
        var reach = Math.max(Math.min(textRight + margin, maxRight), textRight + 24);
        reach = Math.min(reach, vw);
        /* Total width from the left edge; never narrower than the left panel. */
        var totalWidth = Math.max(reach, panelRight);
        sidenav.style.setProperty('--nav-blur-width', Math.round(totalWidth) + 'px');
      }
    }

    /* Only animate text on first reveal, not on re-hover */
    if (!alreadyActive) {
      qsa('.sidebar-grandchild-list li', newGc).forEach(function (li, i) {
        li.classList.remove('textAnimation');
        setTimeout(function () { li.classList.add('textAnimation'); }, i * 60);
      });
    }

    /* Fade out all others */
    qsa('.sidebar-grandchild-container', parentPanel || sidenav).forEach(function (gc) {
      if (gc === newGc) return;
      gc.style.removeProperty('opacity');
      gc.classList.remove('active-background');

      /* Restore original background if overwritten by a plain link hover */
      if (gc.dataset.originalBg !== undefined) {
        gc.style.backgroundImage = gc.dataset.originalBg || '';
        delete gc.dataset.originalBg;
      }

      var gcInner = qs('.sidebar-grandchild-inner-container', gc);
      if (gcInner) gcInner.style.removeProperty('display');
      qsa('.sidebar-grandchild-list li', gc).forEach(function (li) {
        li.classList.remove('textAnimation');
      });
    });
  }

  function openSidenavDesktop(panelTitle) {
    fullReset();
    var matchedPanel = qs('[data-panel-title="' + panelTitle.toLowerCase() + '"]', sidenav);
    if (!matchedPanel) return;
    matchedPanel.classList.add('sidebar-link-active');
    openOverlay();

    /* Apply panel-level default background */
    var panelBg = matchedPanel.dataset.panelBg;
    if (panelBg) {
      var initialGC = qs('.sidebar-grandchild-container-initial', matchedPanel);
      if (initialGC && !initialGC.style.backgroundImage) {
        initialGC.style.backgroundImage = "url('" + panelBg + "')";
        initialGC.style.opacity = '1';
      }
    }

    var childList = qs('.sidebar-child-list', matchedPanel);
    if (childList) childList.classList.add('active-child-link');

    qsa('.menu-toggle', matchedPanel).forEach(function (toggle, i) {
      setTimeout(function () { toggle.classList.add('menu-load-in'); }, i * 80);
    });
  }

  function setupDesktopChildLinks() {
    var hideTimer = null;

    sidenav.addEventListener('mouseenter', function (e) {
      if (isMobile) return;
      var activePanel = qs('.sidebar-link-active', sidenav);
      if (!activePanel) return;

      /* Hovering a child trigger with grandchildren — show them */
      var trigger = e.target.closest('.sidenav-child-trigger');
      if (trigger && trigger.dataset.grandchildId) {
        clearTimeout(hideTimer);
        showGrandchildren(trigger.dataset.grandchildId, activePanel);
        return;
      }

      /* Hovering a child link row that has grandchildren — show them */
      var hasGC = e.target.closest('.child-link.has-grandchildren');
      if (hasGC && hasGC.dataset.grandchildId) {
        clearTimeout(hideTimer);
        showGrandchildren(hasGC.dataset.grandchildId, activePanel);
        return;
      }

      /* Hovering a plain item — show its bg image if set, otherwise clear */
      var plainLink = e.target.closest('.child-link:not(.has-grandchildren)');
      if (plainLink) {
        clearTimeout(hideTimer);
        var bgImage = plainLink.dataset.bgImage;
        if (bgImage) {
          qsa('.sidebar-grandchild-container', activePanel).forEach(function (gc) {
            gc.style.removeProperty('opacity');
            gc.classList.remove('active-background');
          });
          var displayGC = qs('.sidebar-grandchild-container', activePanel);
          if (displayGC) {
            /* Save original background before overwriting */
            if (!displayGC.dataset.originalBg) {
              displayGC.dataset.originalBg = displayGC.style.backgroundImage || '';
            }
            displayGC.style.backgroundImage = "url('" + bgImage + "')";
            displayGC.style.opacity = '1';
            var inner = qs('.sidebar-grandchild-inner-container', displayGC);
            if (inner) inner.style.display = 'none';
          }
        } else {
          hideTimer = setTimeout(function () {
            qsa('.sidebar-grandchild-container', activePanel).forEach(function (gc) {
              gc.style.removeProperty('opacity');
              gc.classList.remove('active-background');
            });
          }, 100);
        }
      }
    }, true);
  }


  /* ==========================================================================
     MOBILE
     ========================================================================== */

  function openSidenavMobile() {
    fullReset();
    openOverlay();

    qsa('.sidebar-link', sidenav).forEach(function (p, i) {
      p.style.display = 'block';
      p.style.opacity = '0';
      p.style.marginTop = '30px';
      setTimeout(function () {
        p.style.transition = 'opacity 0.45s ease, margin-top 0.45s ease';
        p.style.opacity = '1';
        p.style.marginTop = '0';
      }, 100 + i * 100);
    });
  }

  function setupMobileDrillDown() {
    sidenav.addEventListener('click', function (e) {
      if (!isMobile) return;

      /* Third-level links sit INSIDE their parent .child-link.has-grandchildren, so the
         drill-down below would catch them and re-open the panel. Let them navigate. */
      if (e.target.closest && e.target.closest('.sidebar-grandchild-list a')) return;

      /* Back button */
      var backBtn = e.target.closest('.backbtn');
      if (backBtn) {
        e.preventDefault();
        e.stopPropagation();
        mobileBack(backBtn);
        return;
      }

      /* Level 2: tap child link with grandchildren */
      var hasGrandchildren = e.target.closest('.child-link.has-grandchildren');
      var trigger = e.target.closest('.sidenav-child-trigger');
      var grandchildId = (trigger && trigger.dataset.grandchildId) ||
                         (hasGrandchildren && hasGrandchildren.dataset.grandchildId);

      if (grandchildId) {
        e.preventDefault();
        e.stopPropagation();
        var gc = document.getElementById(grandchildId);
        if (!gc) return;
        var childLink = hasGrandchildren || (trigger && trigger.closest('.child-link'));
        if (!childLink) return;

        qsa('.backbtn', sidenav).forEach(function (btn) {
          btn.classList.add('back-second-level');
        });

        childLink.classList.add('active-grandchild-link');

        qsa('.child-link', sidenav).forEach(function (cl) {
          if (!cl.classList.contains('active-grandchild-link')) cl.style.display = 'none';
        });

        var menuToggle = qs('.menu-toggle', childLink);
        if (menuToggle) menuToggle.style.display = 'none';

        gc.classList.add('mobile-active');

        /* Update heading to show child name */
        var activePanel = qs('.sidebar-link.active-menu', sidenav);
        if (activePanel) {
          var heading = qs('.desktop-title', activePanel);
          if (heading) {
            var childName = trigger
              ? trigger.textContent.trim()
              : (childLink.querySelector('.sidenav-child-trigger')
                  ? childLink.querySelector('.sidenav-child-trigger').textContent.trim()
                  : '');
            if (childName) heading.textContent = childName;
          }
        }
        return;
      }

      /* Level 1: tap desktop-title heading */
      var desktopTitle = e.target.closest('.desktop-title');
      if (desktopTitle && desktopTitle.tagName === 'A') return; /* plain link: let it navigate */
      var sidebarLink = desktopTitle ? desktopTitle.closest('.sidebar-link') : null;

      if (sidebarLink && !sidebarLink.classList.contains('active-menu')) {
        e.stopPropagation();
        sidebarLink.classList.add('active-menu');

        var childList = qs('.sidebar-child-list', sidebarLink);
        if (childList) childList.classList.add('active-child-link');

        qsa('.sidebar-link', sidenav).forEach(function (p) {
          if (p !== sidebarLink) p.style.display = 'none';
        });

        qsa('.backbtn', sidenav).forEach(function (btn) {
          btn.style.display = 'block';
          btn.classList.add('back-first-level');
        });

        qsa('.active-child-link .child-link', sidenav).forEach(function (cl, i) {
          cl.style.opacity = '0';
          cl.style.marginTop = '30px';
          setTimeout(function () {
            cl.style.transition = 'opacity 0.45s ease, margin-top 0.45s ease';
            cl.style.opacity = '1';
            cl.style.marginTop = '0';
          }, 100 + i * 100);
        });
      }
    });
  }

  function mobileBack(backBtn) {

    if (backBtn.classList.contains('back-second-level')) {
      var activePanel = qs('.sidebar-link.active-menu', sidenav);
      if (activePanel) {
        var heading = qs('.desktop-title', activePanel);
        if (heading && heading.dataset.originalTitle) {
          heading.textContent = heading.dataset.originalTitle;
        }
      }

      qsa('.sidebar-grandchild-container', sidenav).forEach(function (gc) {
        gc.classList.remove('mobile-active');
      });

      qsa('.child-link', sidenav).forEach(function (cl) {
        cl.classList.remove('active-grandchild-link');
        cl.style.display = '';
        var menuToggle = qs('.menu-toggle', cl);
        if (menuToggle) menuToggle.style.display = '';
      });

      var items = qsa('.active-child-link .child-link', sidenav);
      items.forEach(function (cl, i) {
        cl.style.opacity = '0';
        cl.style.marginTop = '30px';
        setTimeout(function () {
          cl.style.transition = 'opacity 0.45s ease, margin-top 0.45s ease';
          cl.style.opacity = '1';
          cl.style.marginTop = '0';
        }, 100 + i * 100);
      });

      backBtn.classList.remove('back-second-level');
      return;
    }

    if (backBtn.classList.contains('back-first-level')) {
      qsa('.sidebar-link', sidenav).forEach(function (p) {
        var heading = qs('.desktop-title', p);
        if (heading && heading.dataset.originalTitle) {
          heading.textContent = heading.dataset.originalTitle;
        }
        p.classList.remove('active-menu');
      });

      qsa('.active-child-link', sidenav).forEach(function (l) { l.classList.remove('active-child-link'); });
      qsa('.sidebar-grandchild-container', sidenav).forEach(function (gc) { gc.classList.remove('mobile-active'); });

      qsa('.backbtn', sidenav).forEach(function (btn) {
        btn.style.display = 'none';
        btn.classList.remove('back-first-level', 'back-second-level');
      });

      var panels = qsa('.sidebar-link', sidenav);
      panels.forEach(function (p, i) {
        p.style.display = 'block';
        p.style.opacity = '0';
        p.style.marginTop = '30px';
        setTimeout(function () {
          p.style.transition = 'opacity 0.45s ease, margin-top 0.45s ease';
          p.style.opacity = '1';
          p.style.marginTop = '0';
        }, 100 + i * 100);
      });

      // Now, and once the fade-in has finished.
      repaintSidenav();
      setTimeout(repaintSidenav, 100 + panels.length * 100 + 500);
    }
  }

  /* iOS WebKit only redraws the changed area under the frosted (backdrop-filter) panel, so
     backing out of a level left the old list painted below Search / Language (C24, James
     23 Oct; Safari, Chrome, Brave on iPhone). An invisible tint change for one frame
     repaints the whole panel. Not reproducible in Chrome/Blink. */
  function repaintSidenav() {
    sidenav.style.backgroundColor = 'rgba(0, 0, 0, 0.551)';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { sidenav.style.backgroundColor = ''; });
    });
  }


  /* ==========================================================================
     HORIZON INTERCEPTS
     ========================================================================== */

  function interceptHorizonMenu() {
    /* Capture phase fires before Horizon's own handlers */
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.menu-list__link');
      if (!link) return;

      /* TAILOR MADE is a link into its own walled section (not a Global panel):
         let it navigate to the menu's real href (/pages/tailor-made, assigned
         page.tailor-made-landing on launch day). */
      if (link.textContent.trim().toLowerCase() === 'tailor made') return;

      e.preventDefault();
      e.stopImmediatePropagation();
      if (isMobile) {
        openSidenavMobile();
      } else {
        var linkText = link.textContent.trim().toLowerCase();
        var matchedPanel = qs('[data-panel-title="' + linkText + '"]', sidenav);
        if (matchedPanel) openSidenavDesktop(linkText);
      }
    }, true);
  }

  function interceptMobileHamburger() {
    var drawerDetails = document.getElementById('Details-menu-drawer-container');
    if (drawerDetails) {
      var summary = qs('summary', drawerDetails);
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (!isMobile) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          drawerDetails.removeAttribute('open');
          drawerDetails.classList.remove('menu-opening', 'menu-open');
          var menuDrawer = document.querySelector('menu-drawer');
          if (menuDrawer) {
            menuDrawer.removeAttribute('open');
            menuDrawer.classList.remove('menu-opening', 'menu-open');
          }
          openSidenavMobile();
        });
      }
      drawerDetails.addEventListener('toggle', function () {
        if (isMobile && drawerDetails.open) drawerDetails.removeAttribute('open');
      });
    }
    /* Horizon binds the hamburger's on:click="/toggle" on DOCUMENT in the capture
       phase, so an element-level handler runs too late: its (hidden) drawer opens
       and, once the animation ends, traps focus inside itself - nothing in the
       overlay could take focus and the search input could not be typed into
       (2026-09-15). The header is re-rendered, so stripping the attribute does
       not stick. WINDOW capture fires before document capture: handle it here
       and stop propagation so Horizon never sees the click. */
    window.addEventListener('click', function (e) {
      if (!isMobile) return;
      var hamburger = e.target.closest ? e.target.closest('.header__icon--menu') : null;
      if (!hamburger) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var details = document.getElementById('Details-menu-drawer-container');
      if (details) details.removeAttribute('open');
      openSidenavMobile();
    }, true);
  }


  /* ==========================================================================
     CLOSE / ESCAPE / OUTSIDE
     ========================================================================== */
  if (closeBtn) closeBtn.addEventListener('click', closeSidenav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && body.classList.contains('sidenav-open')) closeSidenav();
  });

  document.addEventListener('click', function (e) {
    if (!body.classList.contains('sidenav-open')) return;
    if (!sidenav.contains(e.target)) closeSidenav();
  });


  /* ==========================================================================
     INIT
     ========================================================================== */
  function init() {
    qsa('.sidebar-link', sidenav).forEach(function (panel) {
      var title = qs('.desktop-title', panel);
      if (title) title.dataset.originalTitle = title.textContent.trim();
    });

    interceptHorizonMenu();
    interceptMobileHamburger();
    setupDesktopChildLinks();
    setupMobileDrillDown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();